<template>

    <Page>

        <div class="flex flex-col items-center">
            <div class="w-[60%] mx-auto h-14 absolute bottom-12 transition-all duration-500 ease"
                 style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
            />
            <Image src="/PointOfSale/rewards-window-hangar.png" class="scale-[85%]" />
        </div>
    
    </Page>

</template>